import { render, staticRenderFns } from "./CompanyGroupAdmin.vue?vue&type=template&id=4460a855&"
import script from "./CompanyGroupAdmin.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports